import { createApp } from 'vue'
import { createPinia } from 'pinia'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import ru from 'element-plus/dist/locale/ru.mjs'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHome,
  faShoppingCart,
  faList,
  faUser,
  faSearch,
  faFilter,
  faTrash,
  faPlus,
  faMinus,
  faCheck,
  faXmark,
  faEye,
  faEyeSlash,
  faChevronRight,
  faChevronLeft,
  faRightFromBracket,
  faTriangleExclamation,
  faBoxOpen,
  faReceipt,
  faCreditCard,
  faKey,
  faCapsules,
  faTruck,
  faStore,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHome, faShoppingCart, faList, faUser, faSearch, faFilter,
  faTrash, faPlus, faMinus, faCheck, faXmark, faEye, faEyeSlash,
  faChevronRight, faChevronLeft, faRightFromBracket, faTriangleExclamation,
  faBoxOpen, faReceipt, faCreditCard, faKey, faCapsules, faTruck, faStore,
)

import App from './App.vue'
import router from './router'

import './styles/reset.css'
import './styles/variables.css'
import './styles/app.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: ru })

app.component('FontAwesomeIcon', FontAwesomeIcon)

app.mount('#app')
